module.exports = __webpack_public_path__ + "img/wordmark-ko.54785b49.svg";